import { Text } from '@cad-arc';
import { EventDetailsTabEventDto } from '@mark43/cad-api';
import { FrClickableCard } from '../../../common/components/fr-clickable-card';
import { formatMonthDayYear } from '../../../common/helpers/utils';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../../fr-event-details-page/hooks/use-open-fr-event-details';

export function AssociatedEventCard({
    associatedEvent,
}: {
    associatedEvent: EventDetailsTabEventDto;
}) {
    const openFrEventDetails = useOpenFrEventDetails();

    const { eventNumber, callForService, createdDateUtc, comment, eventId } = associatedEvent;
    const createdDateInDisplayFormat = createdDateUtc ? formatMonthDayYear(createdDateUtc) : null;
    const cardSecondLine = [callForService, createdDateInDisplayFormat]
        .filter((lineItem) => lineItem)
        .join(' ');

    const handleCardClick = () => {
        openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.EVENT_INFO);
    };

    return (
        <FrClickableCard handleCardClick={handleCardClick}>
            <Text fontWeight="semibold">Event #: {eventNumber}</Text>
            <Text style={{ marginTop: 0 }}>{cardSecondLine}</Text>
            {comment && <Text style={{ marginTop: 0 }}>Comments: {comment}</Text>}
        </FrClickableCard>
    );
}
